<template>
  <div data-component-group="pins-dialog" data-component="add-new">
    <dialog-add
      :title="$t('create_pin')"
      content-class="add-pin-dialog"
      icon="gps_fixed"
      is-fullscreen
      :is-on="true"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-pins-add-new
          class="elevation-1"
          :is-loading="isAddingPin"
          :is-on="true"
          :on-cancel="onCancel"
          :on-submit="createPin"
        />
      </template>
    </dialog-add>
  </div>
</template>

<script>
  export default {
    emits: ['saved'],
    created() {
      this.$store.dispatch('pins/clearActiveItem');
    },
    data() {
      return {
        isAddingPin: false,
      };
    },
    computed: {
      parentRoute() {
        return this.$route.matched[0]?.name || 'pins';
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: this.parentRoute, query: this.$route.query });
      },
      createPin(query) {
        this.isAddingPin = true;

        return this.$store
          .dispatch('pins/createItem', query)
          .then((res) => {
            this.$emit('saved');
            this.$router.push({ name: this.parentRoute, query: this.$route.query });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingPin = false;
          });
      },
    },
  };
</script>
